<div class="divider">

</div>
<div class="avoid-break"></div>